import { Checkbox, Col, Divider, Drawer, Row, Typography } from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";

const SetPermission = ({ open, close, setLoading, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [cashiering, setCashiering] = useState(false);
  const [orderOnly, setOrderOnly] = useState(false);
  const [production, setProduction] = useState(false);
  const [waiter, setWaiter] = useState(false);
  const [teamLeader, setTeamLeader] = useState(false);
  const [accounting, setAccounting] = useState(false);
  const [houseKeeping, setHouseKeeping] = useState(false);
  const [inventoryReport, setInventoryReport] = useState(false);
  const [chargeTo, setChargeTo] = useState(false);

  const [stationID, setStationID] = useState(null);

  const [disable, setDisable] = useState(false);
  const { userData } = useContext(UserInfo);
  const [subCategoryList, setSubCategoryList] = useState({
    data: [],
    ready: false,
  });
  // console.log("userData", userData.data.usersmerinfo);

  const onChange = (e, permission) => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.user_id);
    formdata.append("method", e.target.checked ? "create" : "delete");
    formdata.append("permission", permission);

    setDisable(true);
    axios
      .post("user/merchant/update-or-create/permission", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif(
            "success",
            e.target.checked
              ? "Created permission successfully."
              : "Deleted permission successfully."
          );
          setTimeout(() => {
            setDisable(false);
            setLoading(false);
            getEmployeePermission();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };
  // console.log("selectedData.user_id", selectedData.user_id);
  const onChangeStation = (e, stationID) => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.user_id);
    formdata.append("method", e.target.checked ? "create" : "delete");
    formdata.append("station_id", stationID);

    setDisable(true);
    axios
      .post("user/merchant/update-or-create/station", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif(
            "success",
            e.target.checked
              ? "Created station successfully."
              : "Deleted station successfully."
          );
          setTimeout(() => {
            setDisable(false);
            setLoading(false);
            getEmployeePermission();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const getEmployeePermission = useCallback(() => {
    var params = { user_id: selectedData.user_id };
    axios
      .get("user/merchant/get/spec-employee-permission", { params })
      .then((response) => {
        const data = response.data;
        setCashiering(
          data.find(({ permission }) => permission === "cashiering")
            ? true
            : false
        );
        setOrderOnly(
          data.find(({ permission }) => permission === "order-only")
            ? true
            : false
        );
        setProduction(
          data.find(({ permission }) => permission === "production")
            ? true
            : false
        );
        setWaiter(
          data.find(({ permission }) => permission === "waiter") ? true : false
        );
        setTeamLeader(
          data.find(({ permission }) => permission === "team-leader")
            ? true
            : false
        );
        setAccounting(
          data.find(({ permission }) => permission === "accounting")
            ? true
            : false
        );
        setHouseKeeping(
          data.find(({ permission }) => permission === "house-keeping")
            ? true
            : false
        );
        setInventoryReport(
          data.find(({ permission }) => permission === "inventory-report")
            ? true
            : false
        );
        setChargeTo(
          data.find(({ permission }) => permission === "charge-to")
            ? true
            : false
        );
        setStationID(
          data[0].userpermissionstation !== null
            ? data[0].userpermissionstation.station_id
            : null
        );
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [selectedData.user_id]);

  const getAllStation = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/product-sub-category-list", { params })
      .then((response) => {
        const data = response.data;
        // console.log("DATA: ", data);
        setSubCategoryList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getEmployeePermission();

    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-sub-category"
    ) && getAllStation();
  }, [getEmployeePermission, getAllStation]);

  return (
    <Drawer
      title="Set Permission"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Cashiering
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "cashiering")}
            checked={cashiering}
            disabled={disable}
          >
            Handle Customer Payment
          </Checkbox>
        </Col>
        <Col span={24} style={{ marginLeft: 20, marginTop: 10 }}>
          <Checkbox
            onChange={(e) => onChange(e, "order-only")}
            checked={orderOnly}
            disabled={!cashiering || disable}
          >
            Accept orders only
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row
        style={{
          display:
            userData.ready && userData.data.usersmerinfo.is_production === 1
              ? "block"
              : "none",
        }}
      >
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Production
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "production")}
            checked={production}
            disabled={disable}
          >
            Handle Customer Orders
          </Checkbox>
        </Col>
        {userData.data.usersmerpermission.find(
          ({ permission }) => permission === "allow-sub-category"
        ) && (
          <>
            <div
              style={{
                marginLeft: 20,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {subCategoryList.ready &&
                subCategoryList.data.length > 0 &&
                subCategoryList.data.map((data, index) => (
                  <Checkbox
                    onChange={(e) => onChangeStation(e, data.id)}
                    checked={parseInt(stationID) === data.id}
                    disabled={disable}
                    key={index}
                  >
                    {data.sub_category}
                  </Checkbox>
                ))}
            </div>
          </>
        )}
      </Row>
      <Divider />
      <Row
        style={{
          display:
            userData.ready && userData.data.usersmerinfo.is_production === 1
              ? "block"
              : "none",
        }}
      >
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Waiter/Waitress
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "waiter")}
            checked={waiter}
            disabled={disable}
          >
            Handle Customer Orders Distribution
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Team Leader
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "team-leader")}
            checked={teamLeader}
            disabled={disable}
          >
            Handle On/Off Product Status & etc
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Accounting
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "accounting")}
            checked={accounting}
            disabled={disable}
          >
            Handle view/print transaction reports
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      {userData.data.usersmerpermission.find(
        ({ permission }) => permission === "allow-house-keeping"
      ) && (
        <>
          <Row>
            <Col span={24} style={{ marginBottom: 10 }}>
              <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
                Housekeeping
              </Typography>
            </Col>
            <Col span={24}>
              <Checkbox
                onChange={(e) => onChange(e, "house-keeping")}
                checked={houseKeeping}
                disabled={disable}
              >
                Handle update status of the rooms
              </Checkbox>
            </Col>
          </Row>
          <Divider />
        </>
      )}
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Inventory Report
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "inventory-report")}
            checked={inventoryReport}
            disabled={disable}
          >
            Handle inventory report daily or specific date
          </Checkbox>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={24} style={{ marginBottom: 10 }}>
          <Typography style={{ fontSize: 20, fontWeight: "bold" }}>
            Charge To Order
          </Typography>
        </Col>
        <Col span={24}>
          <Checkbox
            onChange={(e) => onChange(e, "charge-to")}
            checked={chargeTo}
            disabled={disable}
          >
            Handle order to charge to specific employee in the store
          </Checkbox>
        </Col>
      </Row>
    </Drawer>
  );
};

export default SetPermission;
